
      import API from "!../../../../../node_modules/.store/style-loader-virtual-bd73274477/package/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../../node_modules/.store/style-loader-virtual-bd73274477/package/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../../../node_modules/.store/style-loader-virtual-bd73274477/package/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../../../node_modules/.store/style-loader-virtual-bd73274477/package/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../../../node_modules/.store/style-loader-virtual-bd73274477/package/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../../../node_modules/.store/style-loader-virtual-bd73274477/package/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../../../node_modules/.store/css-loader-virtual-4b0343164a/package/dist/cjs.js??ruleSet[1].rules[0].oneOf[1].use[1]!./TaskResultItem.module.css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;
options.insert = insertFn.bind(null, "head");
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../../node_modules/.store/css-loader-virtual-4b0343164a/package/dist/cjs.js??ruleSet[1].rules[0].oneOf[1].use[1]!./TaskResultItem.module.css";
       export default content && content.locals ? content.locals : undefined;
